import React, {useState} from "react";
// import {sanitizeInput} from "../../input-validation";
import styles from '../contact-main.module.css'
import FormInputsContainer from "../form/FormInputsContainer";
import emailjs from "@emailjs/browser";
import {isValidInputSet, sanitizeInput} from "../util";
import {FormElement} from "../types";
import Info from "../info/info";
import templateStyles from "../../contact-template.module.css";
import responsive from "../../contact-template.responsive.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import HeroBannerV2 from "../../../banner/v2/regular-left-right/hero-banner-v2";
import FooterXsci from "../../../../common/footer/footer-xsci";
import NavBar from "../../../../v2/layout/navigation/navBar";
import HeroBanner from "../../../../v2/layout/banner/HeroBanner";


const ContactMain: React.FC = () => {



    const [formData, setFormData] = useState<FormElement[]>([
        { name: "Nom du parent", value: "", error: "", type: "text" },
        { name: "Téléphone du parent", value: "", error: "", type: "phone" },
        { name: "Courriel du parent", value: "", error: "", type: "email" },
        { name: "Nom de l’enfant", value: "", error: "", type: "text" },
        { name: "Date de naissance de l’enfant", value: "", error: "", type: "date" },
        { name: "Date de début prévue", value: "", error: "", type: "date" },
        { name: "Message", value: "", error: "", type: "textarea" },
    ]);

    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const pbK = "yPJo-myVbTj93UlQZ"
    const templ = "template_f7tcvuj"
    const srvc = "service_8obvoeq"


    // HANDLE INPUT CHANGE
    const updateInputValueChange = (inputField: any,newValue: any) => {
        const sanitizedValue = sanitizeInput(newValue); // Apply sanitization
        setFormData(prevInputs =>
            prevInputs.map(input =>
                input.name === inputField ? { ...input, value: sanitizedValue, error: '' } : input
            )
        );
    };


    // const print = (e: React.MouseEvent<HTMLButtonElement>) => {
    //     e.preventDefault(); // stops page refresh
    //     console.log(formData);
    // };

    const sendEmailData = (e: React.FormEvent) => {
        e.preventDefault();

        const { updatedData, isValid } = isValidInputSet(formData);
        setFormData(updatedData); // <-- update form with errors

        if (isValid) {
            setIsLoading(true); // Show the loader when form is submitted
            // Prepare the form data as an object to be sent via EmailJS
            const emailData = {

                parent_name: sanitizeInput(formData.find((field) => field.name === 'Nom du parent')?.value || ''),
                parent_phone: sanitizeInput(formData.find((field) => field.name === 'Téléphone du parent')?.value || ''),
                parent_email: sanitizeInput(formData.find((field) => field.name === 'Courriel du parent')?.value || ''),
                child_name: sanitizeInput(formData.find((field) => field.name === 'Nom de l’enfant')?.value || ''),
                child_db: sanitizeInput(formData.find((field) => field.name === 'Date de naissance de l’enfant')?.value || ''),
                anticipated_start_date: sanitizeInput(formData.find((field) => field.name === 'Date de début prévue')?.value || ''),
                message: sanitizeInput(formData.find(f => f.name === "Message")?.value || ''),

            };

            console.log(emailData);

            // Send email using EmailJS service
            emailjs
                .send(srvc, templ, emailData, pbK)
                .then(
                    (result) => {
                        console.log("message result", result.text);
                        setIsLoading(false); // Hide loader
                        setIsSuccess(true); // Show success checkmark
                        setTimeout(() => {
                            window.location.reload(); // Reload page after success
                        }, 2000); // Delay before reloading
                    },
                    (error) => {
                        console.log(error.text);
                        setIsLoading(false); // Hide loader on error
                        alert('There was an error sending the email.');

                    }
                );
        }
    }


    return (
        <>
            <NavBar/>
            {/*<HeroBannerV2*/}
            {/*    coloredTitle={[*/}
            {/*        { text: "Contactez-nous", color: '#5A3B76'  },*/}
            {/*    ]}*/}
            {/*    showButton = {false}*/}
            {/*    backgroundImageUrl={"/images/banner/contactus.jpg"}*/}
            {/*/>*/}
            <HeroBanner
                title={"Contactez notre garderie à La Prairie"}
                subTitle={"Planifiez une visite dès aujourd'hui"}
                subTitle2={""}
                imageUrl={"/images/banner/contact.png"}
                hideCta={true}
            />
            <div className={styles.container}>
                <div className={`${styles.box} ${styles.left}`}>
                    <p>
                        Pour plus de renseignements, ou pour réserver une visite, contactez‑nous ou remplissez le formulaire.
                        Nous avons hâte de vous rencontrer.
                    </p>
                    <FormInputsContainer
                        formData={formData}
                        onChange={updateInputValueChange} // updates formData in parent
                        sendEmailData={sendEmailData}     // submit handler
                    />
                </div>
                {/* Loader and Success Modal */}
                {(isLoading || isSuccess) && (
                    <div className={`${templateStyles.overlay}`}>
                        {isLoading ? (
                            <div className={`${templateStyles.loader}`}></div>
                        ) : (
                            <div  className={`${templateStyles.success_check} ${responsive.success_check}`}>
                                {<FontAwesomeIcon icon={faCheck} className={`${templateStyles.success_icon}`}/>}
                                Courriel envoyé
                            </div>
                        )}
                    </div>
                )}
                <div className={`${styles.box} ${styles.right}`}>
                    <Info/>
                </div>
            </div>
            <FooterXsci/>
        </>
    );
};

export default ContactMain;
